import { useReducer } from 'react';

export const useObjectState = <T extends object>(initialState: T) =>
  useReducer(
    (state: T, newState: Partial<T>): T => ({ ...state, ...newState }),
    initialState
  );
